(function () {
  const initProductAccordion = (section) => {
    if (!section || section.getAttribute("data-dropdowns-initialized")) return;
    const dropdowns = section.querySelectorAll("[data-product-dropdown]");
    dropdowns.forEach((dropdown) => {
      const toggle = dropdown.querySelector("[data-product-dropdown-toggle]");
      const content = dropdown.querySelector("[data-product-dropdown-content]");
      if (!toggle || !content) return;
      toggle.addEventListener("click", (event) => {
        event.preventDefault();
        if (!toggle.classList.contains("active")) {
          slideDown(toggle, content, 300); // func in global.js
        } else {
          slideUp(toggle, content, 300); // func in global.js
        }
      });
    });
    section.setAttribute("data-dropdowns-initialized", "true");
  };
  document.addEventListener("shopify:section:load", (event) => {
    initProductAccordion(event.target);
  });
  initProductAccordion(document.currentScript.parentElement);
})();
